import { Themes, useIsSectionThemeDark } from '@contexts/section-theme-context'
import { usePageTheme } from '@contexts/page-theme-context'
import { getThemeFromBackgroundColor } from '@components/page-section/theme'
import { BackgroundColor } from '@lib/types/background'

/**
 * Get current theme per section based on page theme and section background
 */
export const useSectionTheme = (backgroundColor?: BackgroundColor) => {
  const isDarkThemeSection = useIsSectionThemeDark()
  const { color } = usePageTheme()

  if (isDarkThemeSection) {
    return Themes.Dark
  }

  return getThemeFromBackgroundColor(backgroundColor, color === 'convertTo2024')
}
